import { createClient } from '@pankod/refine-supabase';

const SUPABASE_URL = 'https://bqlaqlcjtcpuwwrnhzqt.supabase.co';
const SUPABASE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYzNzYxMDk4MiwiZXhwIjoxOTUzMTg2OTgyfQ.rPzyG9iIPm0usjPx8-OFGg5x5wYSXyl3BPU59g0ssAI';

export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_KEY);
